export default __webpack_public_path__ + "static/media/oliver-lobo.96315c94.jpg";